<template>
  <div>
    <v-dialog v-model="value" max-width="1100" scrollable persistent>
      <v-card outlined :loading="isLoading">
        <v-overlay absolute v-if="isLoading" opacity="1" color="white">
          <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
        </v-overlay>
        <v-card-title class="d-flex justify-space-between align-center primary white--text">
          <div> {{ $t('meter.sell_unit_meter') }} </div>
          <v-btn color="white" icon @click="$emit('input', false),$emit('onClose');">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="flex justify-between align-center my-5">
            <div class="flex align-center gap-2 darkprimary--text">
              <h3 class="font-weight-bold">{{detailOrder.meter && detailOrder.meter.isMain ? $t('meter.main_meter') : $t('meter.sub_meter') }}</h3>
              <div>
                <v-chip class="chip-status info">
                  {{ $t('prepaid') }}
                </v-chip>
              </div>
              <h3>({{ $t('area.space') }} {{ area ? area.name : ''}} )</h3>
            </div>
            <h3 class="darkprimary--text font-weight-bold">{{ $t('area.shop_name') }}: {{area ? area.businessName : '-'}}</h3>
          </div>  

          <div class="box-information">
            <div class="header">
              <div class="font-weight-bold">{{ $t('customer.customer_information') }}</div>
              <v-btn color="warning" dark elevation="0" @click="getObjectUpdate" :disabled="isSaving || isSendOrder || isLoading">
                <v-icon dark left>mdi-pencil</v-icon>{{ $t('customer.edit_trader_data') }}
              </v-btn>
            </div>
            <div class="body">
              <div class="d-flex flex-wrap ">
                <div class="me-5 mb-3"><b class="me-3">{{ $t('customer.company_name_and_customer_name') }}</b> {{ billingData.name || '-'}}</div>
                <div class="me-5 mb-3"><b class="me-3">{{ $t('market.company_branch_long') }}</b> {{billingData.branchName || '-'}}</div>
                <div class="me-5 mb-3"><b class="me-3">{{ $t('address.address_detail') }}</b> {{ billingData.address || '-'}}</div>
                <div class="me-5 mb-3"><b class="me-3">{{ $t('tax.tax_id_number_another_form') }}</b> {{ billingData.taxId || '-'}}</div>
                <div class="me-5 mb-3"><b class="me-3">{{ $t('account.phone_number') }}</b> {{ billingData.tel || '-'}}</div>
                <div class="me-5 mb-3"><b class="me-3">Email</b> {{ billingData.email || '-'}}</div>
              </div>
            </div>
          </div>

          <div class="box-meter-info">
            <div class="meter-current-info">
              <div class="status-meter">
                <v-chip class="chip-text mr-2 my-1 outline-dark-primary">
                  <v-icon left x-small> mdi-circle </v-icon>
                  {{ $t('online') }}
                </v-chip>
              </div>
              <div class="text-center">
                <img src="@/assets/images/meter-icon.png" alt="meter" class="icon-meter">
                <v-chip class="chip-status info">
                  {{ $t('prepaid') }}
                </v-chip>
              </div>
              <div>
                <h3 class="darkwarning--text font-weight-bold mb-3">{{detailOrder.meter && detailOrder.meter.isMain ? $t('meter.main_meter') : $t('meter.sub_meter') }}</h3>
                <h3 class="darkgrey--text font-weight-bold mb-3">{{ $t('area.space') }} {{detailOrder.meter && detailOrder.meter.area ? detailOrder.meter.area.name : ''}} </h3>
                <h5 class="darkgrey--text mb-1">{{ $t('meter.current_unit') }}</h5>
                <h5 class="darkwarning--text">{{detailOrder.meter ? $helper.toCurrency(detailOrder.meter.unit) : null}} {{ $t('meter.unit_kwh') }}</h5>
              </div>
            </div>
            <div class="meter-history">
              <div class="header">
                {{ $t('meter.last_sell_unit') }}
              </div>
              <div class="body">
                <div class="history-container" v-if="historyData">
                  <div class="history-item" v-for="(history,index) in historyData" :key="index">
                    <div>
                      <h5 class="darkgrey--text font-weight-bold">{{ $t('meter.sell_unit') }}</h5>
                      <h5 class="gray--text">{{$helper.toCurrency(history.totalUnit)}} {{ $t('unit') }}</h5>
                    </div>
                    <div class="text-end">
                      <h5 class="primary--text font-weight-bold">{{ history.totalValue | currencyPrefixSign }}</h5>
                      <h5 class="gray--text">{{ $helper.dateTH(history.createdAt)  }}</h5>
                      <h6 class="gray--text"> {{ $t('customer.operation_by') }} : {{history.createdBy ? history.createdBy.firstName + ' ' + history.createdBy.lastName : '-'}}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="box-sell-meter">
            <v-alert 
              v-if="billingSettingByMeters && billingSettingByMeters.length > 0"
              border="left"
              color="info"
              text
              class="alert-unit">
              <span v-for="(setting ,index)  in billingSettingByMeters" :key="`setting_`+index">
                {{  setting.accountingProduct.name }} 
                <template v-if="setting.discountType == 2">{{ $helper.round(setting.cost - (setting.cost * (setting.discount || 0) /
                  100)) | currencySuffixTextThEn }} 
                </template>
                <template v-else>{{ setting.cost - (setting.discount || 0) | currency }}</template>
                / 1 {{ $t('meter.unit_kwh') }}{{ index < billingSettingByMeters.length - 1 ? ', ' : '' }}
              </span>
            </v-alert>
            <v-alert 
              v-else
              border="left"
              color="error"
              text
              dense
              class="alert-unit">
              {{ $t('validate.please_set_electricity_price_that') }}
              <v-btn
                class="btn-link"
                link
                text
                :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/setting/elec`"
                >
                <div class="error--text text-decoration-underline">{{ $t('market.setting_meter_elec') }}</div>
              </v-btn>
            </v-alert>


            <div class="sell-section">
              <div :class="!swapMode ? 'order-1' : 'order-3'">
                <div class="mb-1 black--text">
                  {{ $t('payment.amount') }} :
                </div>
                <v-currency-field
                  :label="$t('payment.amount')"
                  single-line
                  outlined
                  dense
                  hide-details
                  step="1"
                  min="0"
                  v-model="inputSell.cost"
                  class='bg-white'
                  @input="calculateOnInput('cost')"
                  :disabled="isSaving || isLoading || isSendOrder || swapModeType != 'cost'"
                />
              </div>
              <div class="order-2">
              <v-btn
                color="darkwarning"
                depressed
                elevation="8"
                fab
                raised
                small
                @click="swapInput"
                :disabled="isSaving || isLoading || isSendOrder"
              >
                <img width="20" :src="require(`@/assets/images/swap.svg`)" />
              </v-btn>
              </div>  
              <div :class="!swapMode ? 'order-3' : 'order-1'">
                <div class="mb-1 black--text">
                  {{ $t('meter.electricity_unit_kwh') }}
                </div>
                <v-currency-field
                  :label="$t('meter.electricity_unit_kwh')"
                  single-line
                  outlined
                  dense
                  hide-details
                  v-model="inputSell.unit"
                  step="1"
                  min="0"
                  class='bg-white'
                  @input="calculateOnInput('unit')"
                  :disabled="isSaving || isLoading || isSendOrder || swapModeType != 'unit'"
                />
              </div>
            </div>

            <div class="history-buy-unit">
              <div class="mt-3 mb-2">{{ $t('meter.topup_unit_history') }}</div>
              <div>
                <template v-if="!swapMode">
                  <template v-for="(history, index) in historySellCost"  >
                    <v-btn v-if="history.totalValue > 0"
                    :key="index"
                    class="btn-history me-3 mb-2" 
                    :class="selectHistory == history.totalValue ? 'active' : ''" 
                    @click="selectUnitHistory(history.totalValue)" 
                    :disabled="isSaving || isSendOrder|| isLoading"
                   >
                    {{$helper.toArabic(history.totalValue)}} {{ $helper.currencyThEn() }}
                  </v-btn>
                  </template>
                </template>
                <template v-else>
                  <template v-for="(history, index) in historySellUnits" >
                    <v-btn 
                    v-if="history.totalUnit > 0"
                    :key="index"
                    class="btn-history me-3 mb-2" 
                    :class="selectHistory == history.totalUnit ? 'active' : ''" 
                    @click="selectUnitHistory(history.totalUnit)" 
                    :disabled="isSaving || isSendOrder || isLoading"
                   >
                    {{$helper.toArabic(history.totalUnit)}} {{ $t('unit') }}
                  </v-btn>
                  </template>
                
                </template>
              </div>
            </div>
          </div>

          <div class="box-list-product">
            <div  class="d-flex justify-end mb-5" >
              <div style="max-width:250px;width:100%;">
                <v-row>
                  <v-col cols="5" class="py-0">
                    <p class="summary-topic font-weight-bold">{{ $t('product.product_price') }}:</p>
                  </v-col>
                  <v-col cols="7" class="py-0 ps-0 text-right">
                    <p class="summary-number pe-5 me-2">{{project && project.isVatInclusive ? $t('tax.total_tax') : $t('payment.price_vat_exclusive')}}</p>
                  </v-col>
                </v-row>
              </div>
            </div>

            <div style="border-radius: 10px; overflow: hidden">
              <v-simple-table v-if="formData.items && formData.items.length">
                <template v-slot:default>
                  <thead class="table-item header rounded-2">
                    <tr>
                      <th width="3%" class="text-center">{{ $t('rank') }}</th>
                      <th>{{ $t('product.product_name_and_detail') }}</th>
                      <th>{{ $t('area.space') }}</th>
                      <th width="8%" class="text-center">{{ $t('product.quantity') }}</th>
                      <th width="8%">{{ $t('unit') }}</th>
                      <th width="10%" class="text-center">{{ $t('product.unit_price') }}</th>
                      <th width="10%" class="text-center">{{ $t('product.discount_unit') }}</th>
                      <th width="10%">{{ $t('product.vat') }}</th>
                      <th width="10%">{{ $t('accounting_product.withholding_tax') }}</th>
                      <th width="10%" class="text-center">{{ $t('product.total_price') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in formData.items" :key="index">
                      <td class="py-2 text-center vertical-top">{{ index + 1 }}</td>
                      <td class="py-2 vertical-top">
                        {{item.name}}
                        {{item.detail ? ' / ' + item.detail : ''}}
                      </td>
                      <td class="py-2 vertical-top">
                        {{detailOrder.meter ? detailOrder.meter.area.name : '-'}}
                        {{detailOrder.meter ? `(${detailOrder.meter.area.size}) ${ $t('square_meter')}` : '-'}}
                      </td>
                      <td class="py-2 text-center vertical-top">
                        {{ $helper.toCurrency(item.quantity) }}
                      </td>
                      <td class="py-2 text-center vertical-top">
                        {{item.unit}}
                      </td>
                      <td class="py-2 text-center vertical-top">
                        {{ $helper.toCurrency(item.originalPricePerUnit) }}
                      </td>
                      <td class="py-2 text-center vertical-top">
                        {{ $helper.toCurrency(item.discountPerUnit) }}
                      </td>
                      <td class="py-2 text-center vertical-top">
                        {{ item.sellVatType == 1 
                          ? formData.vatPercent + '%'
                          : item.sellVatType == 2
                          ? '0%'
                          : item.sellVatType == 3 
                          ? $t('except') 
                          : '-'
                          }} 
                      </td>
                      <td class="py-2 text-center vertical-top">
                        {{ item.totalWhtValue | currency }}
                      </td>
                      <td class="py-2 text-center vertical-top">
                        <b>{{ item.totalOriginalValue | currency }}</b>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

          </div>

          <!-- Summary -->
          <div class="box-payment-container pt-5 mt-5">
            <div class="box-payment">
              <div>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic font-weight-bold">{{ $t('payment.total_amount') }}:</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number font-weight-bold">{{ formData.totalOriginalValue | currencyPrefixSign }}</p>
                  </v-col>
                </v-row>
                <div class="divider-dashed my-4"></div>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_discount_amount_value') }}:</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalDiscountValue | currencyPrefixSign }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_exempt_value') }}:</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalNonVatItemsValue | currencyPrefixSign }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_calculated_value') }}:</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalVatItemsValue | currencyPrefixSign }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_vat') }}:</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalVatValue | currencyPrefixSign }}</p>
                  </v-col>
                </v-row>
                <div class="text-right"></div>
                <div class="divider-dashed my-4"></div>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic bold">{{ $t('market.total_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number bold">{{ formData.totalValue | currencyPrefixSign }}</p>
                  </v-col>
                </v-row>
                <div>
                  <div class="divider-dashed mt-4"></div>
                  <v-row class="mt-2" v-if="isWht">
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic">{{ $t('tax.tax_withholding') }}:</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number">{{ formData.totalWhtValue | currencyPrefixSign }}</p>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
          
          <div class="mt-5">
            <v-alert color="#E7FCE3">
              <v-row class="py-2">
                <v-col cols="7" class="py-0">
                  <p class="summary-topic bold darkprimary--text">{{ $t('payment.total_amount_to_pay') }}</p>
                </v-col>
                <v-col cols="5" class="py-0 text-right">
                  <p v-if="isWht" class="summary-number bold darkprimary--text">
                    {{
                    (formData.totalValue - formData.totalWhtValue)
                      | currencySuffixTextThEn
                    }}
                  </p>
                  <p v-else class="summary-number bold darkprimary--text">
                    {{formData.totalValue | currencySuffixTextThEn }} 
                  </p>
                </v-col>
              </v-row>
            </v-alert>
          </div>
        
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-spacer></v-spacer>
          <div class="me-2">
            <b><span class="black--text">{{ $t('payment.total_amount_all') }}</span> <span class="success--text">
             {{(formData.totalValue - formData.totalWhtValue) | currencySuffixTextThEn }}
              </span>
            </b>
          </div>
          <v-btn
            v-if="!isSendOrder"
            color="success"
            type="submit"
            elevation="0"
            :disabled="isSaving || (formData.totalValue - formData.totalWhtValue <= 0  || inputSell.cost < 1 || inputSell.unit < 0.1)"
            :loading="isSaving"
            @click="createOrderMeter();">
            {{ $t('payment.save_and_pay') }}
          </v-btn>
          <v-btn
            v-else-if="isSendOrder && order"
            color="success"
            type="submit"
            elevation="0"
            :disabled="isSaving || (formData.totalValue - formData.totalWhtValue <= 0  || inputSell.cost < 1 || inputSell.unit < 0.1)"
            :loading="isSaving"
            @click="isPaymentFormDialog = true;">
            {{ $t('payment.pay') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <BillHederDialog v-if="!isLoading" v-model="isBillHederDialog" :customerType="customerType ? customerType : null"
      :customerData="formData.customerData" @onSaveCustomerDataMeter="onSaveSuccess" />  
      
    <PaymentFormDialog v-model="isPaymentFormDialog" :projectId="projectId" 
    :order="order"
    :isHideSplitPay="true"
    :paymentMethod="tempInvoicePayment ? tempInvoicePayment.paymentMethod : null"
    :paymentProofFiles="tempInvoicePayment ? tempInvoicePayment.paymentProofFiles : null"
    :paymentBankAccount="tempInvoicePayment ? tempInvoicePayment.paymentBankAccount : null"
    @onSaveSuccess="onSaveSuccessPayment" />
  </div>

</template>

<script>
import { mapGetters, mapMutations ,mapActions} from "vuex";
import BillHederDialog from "./BillHederDialog.vue";
import PaymentFormDialog from "./paymentFormDialog.component.vue";
import { Customer, DocumentItem , Order} from "../classes";
export default {
  components: {
    BillHederDialog,
    PaymentFormDialog
  }, 
  computed: {
    ...mapGetters({
      billingSettingByMeters: "billingSetting/getBillingSettingsQuantity",
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
    historySellCost(){
      let data = null;
      if(this.historyData){
        data = this.historyData.filter((item, index, self) => 
        index === self.findIndex((t) => t.totalValue === item.totalValue)
        );
      }
      return data;
    },
    historySellUnits(){
      let data = null;
      if( this.historyData){
        data = this.historyData.filter((item, index, self) => 
          index === self.findIndex((t) =>  t.totalUnit === item.totalUnit)
        );
      }
      return data;
    },
    isWht() {
      if(this.formData.items){
        return this.formData.items.filter(d => d.whtPercent > 0).length > 0;
      }
    },
  },
  props : {
    value : Boolean,
    meterId : String,
    projectId : String,
    marketId : String,
    contract : Object,
    area : Object,
    booking : Object,
  },
  data(){
    return {
      isLoading: false,
      isSaving: false,
      isBillHederDialog: false,
      isPaymentFormDialog : false,
      obj : {},
      project: null,
      rateUnit : 0,
      formData : {},
      meters : {},
      inputSell : {
        unit : null,
        cost : null,
      },
      customerType : '',
      historyData : [],
      selectHistory : null,
      swapMode : false,
      swapModeType : 'cost',
      hashDigitalMetersUnit : {},
      detailOrder : {
        area : null,
        meter : null,
      },
      order : null,
      isSendOrder : false,
      billingData : {
        name: "",
        address: "",
        taxId: "",
        branchName: "",
        tel: "",
        email: ""
      },
      receipt : null,
      tempInvoicePayment : {
        paymentMethod : null,
        paymentProofFiles : null,
        paymentBankAccount : null,
      },
    }
  },
  async created() {
    try {
      if (this.admins && this.admins.length) {
        this.project = this.admins[0].project;
      }
      if (this.employees && this.employees.length) {
        this.project = this.employees[0].project;
      }
    } catch (error) {
      this.isLoading = false;
      this.isError = true;
    }
  },
  mounted(){
  },
  methods: {
    ...mapActions({
      createOrder : 'order/createOrder',
      sendOrder : 'order/sendOrder',
      getLatestMeterData: 'digitalMeter/getLatestMeterData',
      getMeter : 'meter/getMeter',
      getLastOrderByMeter : 'order/getLastOrderByMeter',
      getOrder : 'order/getOrder'
    }),
    async initData(){
      this.isLoading = true;
      try {
        this.historyData = null;
        this.isSendOrder = false;
        this.formData = {};
        this.inputSell.unit = 0;
        this.inputSell.cost = 0;
        this.selectHistory = null;

        await this.loadMeterById();
        await this.loadBillingSettingByMeters();
        await this.loadSellLogs();

        if(this.booking && this.contract || this.booking && !this.contract){
          if(this.booking.booking){
            this.billingData = Customer.getBillingDataByCustomer(this.booking.booking.customer)
            this.customerType = this.booking.booking.customer.type
          }
        }else if(this.contract){
          this.billingData = {
            name: this.contract.billingData.name,
            address: this.contract.billingData.address,
            taxId: this.contract.billingData.taxId,
            branchName: this.contract.billingData.branchName,
            tel: this.contract.billingData.tel,
            email: this.contract.billingData.email
          }
          this.customerType = this.contract.customer.type
        }

        this.prepareMeterSetting();        
        this.isLoading = false;

      } catch (error) {
        this.isLoading = false;
        this.isSaving = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    async loadMeterById(){
      try {
        this.meter = await this.getMeter(this.meterId);
        this.hashDigitalMetersUnit = await this.getLatestMeterData({
          partner: this.meter.digitalMeterData.partner,
          type: this.meter.digitalMeterData.type,
          cust_id: this.meter.digitalMeterData.cust_id,
          meterAddress: this.meter.digitalMeterData.meter_id,
          datetime: new Date()
        });

        this.detailOrder = {
          area: this.area,
          meter: {
            ...this.meter,
            ...this.hashDigitalMetersUnit[`${this.meter.digitalMeterData.cust_id}_${this.meter.digitalMeterData.meter_id}`]
          }
        };
      } catch (error) {
        console.error('Error loading meter:', error);
        this.$toast.show({
          content: this.$t('validate.error_loading_meter_data'),
          color: "error"
        });
      }
    },
    async loadBillingSettingByMeters(){
      await this.$store.dispatch("billingSetting/getBillingSettingsByMeters",{
        meterIds: [this.meterId],
        currencyCode: this.$globalCurrencyCode
      });
    },
    async loadSellLogs(){
      this.historyData = await this.getLastOrderByMeter(this.meterId)
    },
    prepareMeterSetting(){
      let items = [];
      let costMeter = 0;
      let cost = parseFloat(this.inputSell.cost) || 0;
      let unit = parseFloat(this.inputSell.unit) || 0;
      this.rateUnit = 0;

      this.inputSell.cost = cost;
      this.inputSell.unit = unit;

      for(let settingMeter of this.billingSettingByMeters){
        let quantity = 0;
        if(settingMeter.meter.objectId === this.meterId){
          if(settingMeter.discountType == 2){
            costMeter = settingMeter.cost - (settingMeter.cost * (settingMeter.discount || 0) / 100)
          }else{
            costMeter = settingMeter.cost - (settingMeter.discount || 0) 
          }
          this.rateUnit += costMeter;
        }
        quantity = unit;
        const item = {
          quantity: quantity,
          name: settingMeter.accountingProduct.name,
          unit: settingMeter.accountingProduct.unit,
          sellVatType: settingMeter.accountingProduct.sellVatType,
          whtPercent: settingMeter.accountingProduct.whtPercent,
          type: settingMeter.accountingProduct.type,
          discountType: settingMeter.discountType,
          originalPricePerUnit: settingMeter.cost,
          discount: settingMeter.discount || 0,
          discountPerUnit : settingMeter.discount || 0,
          area: settingMeter.area,
          billingSetting : settingMeter,
          meter : this.meter,
          accountingProduct : settingMeter.accountingProduct
        };
        items.push(item);
      }
      this.formData = new Order({
        customerData: this.billingData,
        items: items,
        date: { iso: this.$moment().toISOString() },
        isVatInclusive: this.project ? this.project.isVatInclusive : false
      });
    },
    preparePostData() {
      let postData = {};
      postData.id = this.formData.objectId;
      if(this.booking && this.contract || this.booking && !this.contract){
        postData.bookingId = this.booking ? this.booking.booking.objectId : null;
      }else if(this.contract){
        postData.contractId = this.contract ? this.contract.objectId : null;
      }
      postData.meterId = this.meterId;
      postData.customerData = this.formData.customerData || {};
      postData.type = this.documentType || 1;
      postData.items = this.formData.items.map(d => {
        let obj = {};
        if (d.area) {
          if (!d.area.isRemove) {
            obj.area = d.area;
          }
        }
        if (d.meter) obj.meter = d.meter;
        if (d.accountingProduct) obj.accountingProduct = d.accountingProduct;
        if (d.billingSetting) obj.billingSetting = d.billingSetting;
        obj.name = d.name;
        obj.detail = d.detail;
        obj.unit = d.unit;
        obj.quantity = d.quantity;
        obj.originalPricePerUnit = d.originalPricePerUnit;
        obj.sellVatType = d.sellVatType;
        obj.whtPercent = d.whtPercent;
        obj.totalValue = d.totalValue;
        obj.totalVatValue = d.totalVatValue;
        obj.totalNonVatValue = d.totalNonVatValue;
        obj.totalWhtValue = d.totalWhtValue;
        obj.type = d.type;
        obj.discountType = d.discountType;
        obj.discountPerUnit = d.discountPerUnit;
        obj.originalDiscountPerUnit = d.originalDiscountPerUnit;
        obj.totalDiscountValue = d.totalDiscountValue;
        obj.totalDiscountVatValue = d.totalDiscountVatValue;
        obj.totalDiscountNonVatValue = d.totalDiscountNonVatValue;
        return obj;
      });
      postData.totalValue = this.formData.totalValue;
      postData.totalUnit =  this.$helper.round(this.inputSell.unit);
      postData.totalVatValue = this.formData.totalVatValue;
      postData.totalNonVatValue = this.formData.totalNonVatValue;
      postData.totalVatItemsValue = this.formData.totalVatItemsValue;
      postData.totalNonVatItemsValue = this.formData.totalNonVatItemsValue;
      postData.totalWhtValue = this.formData.totalWhtValue;
      postData.totalDiscountValue = this.formData.totalDiscountValue;
      postData.totalDiscountVatValue = this.formData.totalDiscountVatValue;
      postData.totalDiscountNonVatValue = this.formData.totalDiscountNonVatValue;
      postData.isVatInclusive = this.formData.isVatInclusive;
      postData.note = this.formData.note;
      postData.date = new Date();
      return postData;
    },
    getObjectUpdate() {
      this.isBillHederDialog = true;
    },
    selectUnitHistory(val){
      if(!this.swapMode){
        this.selectHistory = val;
        this.inputSell.cost = val;
      }else{
        this.selectHistory = val;
        this.inputSell.unit = val;
      }
      this.calCulateSellUnit();
    },
    calCulateSellUnit(){
      let cost = this.inputSell.cost
      let unit = this.inputSell.unit
      if(!this.swapMode){
        this.inputSell.unit = this.$helper.round(cost / this.rateUnit);
      }else{
        this.inputSell.cost = this.$helper.round(unit * this.rateUnit);
      }
    },
    calculateOnInput(type) {
      let cost = this.inputSell.cost
      let unit = this.inputSell.unit
      if (type === 'cost' && !this.swapMode) {
        this.inputSell.unit = this.$helper.round(cost / this.rateUnit);
        this.selectHistory = this.inputSell.cost;
      } else if (type === 'unit' && this.swapMode) {
        this.inputSell.cost = this.$helper.round(unit * this.rateUnit);
        this.selectHistory = this.inputSell.unit;
      }
    },
    swapInput(){
      this.swapMode = !this.swapMode
      this.swapModeType = this.swapMode ? 'unit' : 'cost';
      if (this.swapModeType === 'cost' && !this.swapMode) {
        this.selectHistory = this.inputSell.cost;
      } else if (this.swapModeType === 'unit' && this.swapMode) {
        this.selectHistory = this.inputSell.unit;
      }
      this.calCulateSellUnit();
    },
    async createOrderMeter(){
      this.isSaving = true;
      try {
        let form = this.preparePostData();
        let result = await this.createOrder(form);
        await this.sendOrder({id : result.objectId, date: new Date()});
        this.order = await this.getOrder(result.objectId)
        if(this.order){
          this.isSendOrder = true;
          this.isPaymentFormDialog = true;
          this.$emit("onSaveSuccess");
        }
        this.isSaving = false;
      } catch (error) {
        this.isSaving = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }   
    },
    onSaveSuccess(val) {
      try {
        this.billingData = {
          name: val.name,
          address: val.address,
          taxId: val.taxId,
          branchName: val.branchName,
          tel: val.tel,
          email: val.email
        }
        this.prepareMeterSetting();
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    async onSaveSuccessPayment(data) {
      this.isSaving = true;
      try {
        if (data.paymentMethod != 7) {
          let receipt = null;
          let paymentData = {
            date: data.date,
            paymentMethod: data.paymentMethod,
            paymentBankAccount: data.paymentBankAccount,
            paymentNote: data.paymentNote,
            paymentProofFiles: data.paymentProofFiles,
            paymentCurrencyCode: data.paymentCurrencyCode,
            totalPaymentValue: data.totalPaymentValue,
            exchangeRate: data.exchangeRate,
            voucherNumber: data.voucherNumber
          };
          if(!receipt){
            receipt = await this.$store.dispatch("receipt/createReceipt", {
              orderId: this.order.objectId
            });
          }
          if (receipt) {
            paymentData.id = receipt.objectId;
            await this.$store.dispatch("receipt/payReceipt", paymentData);
          }
        }
        this.$emit("onSaveSuccess");
        this.$emit('input', false)
        this.isSaving = false;
        return true;
      } catch (error) {
        this.isSaving = false;
        this.isError = true;
      }
    },
  },
  watch: {
    'inputSell.cost': {
      handler(newValue, oldValue) {
        this.prepareMeterSetting();
      },
      deep: true, 
    },
    value(){
      if(this.value){
       this.initData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .box-information{
    border-radius: 5px;
    border: 1px solid #E4E6E8;
    .header{
      color: #424242;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color:#EEEEEE;
      padding: 15px;
      font-size: 16px;
    }
    .body{
      padding: 15px;
      color:#424242;
      font-size: 16px;
    }
  }

.summary-topic {
  margin: 5px 0;
  color: #424242;
  font-weight: 400;
  font-size: 16px;
  &.bold {
    font-weight: 600;
  }
}

.summary-number {
  margin: 5px 0;
  font-weight: 400;
  color: #424242;
  font-size: 16px;
  &.bold {
    font-weight: 700;
  }
}

.box-meter-info{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin: 20px 0;
  .meter-current-info{
    display: flex;
    align-items:center;
    justify-content: space-evenly;
    background-color: #FAFAFA;
    position: relative;
    border-radius: 10px;
    .status-meter{
      position: absolute;
      // top: 5px;
      // right: 5px;
      top: -2px;
      right: -9px;
    }
    .icon-meter{
      max-width: 100px;
      width: 100%;
    }
  }

  .meter-history{
    border-radius: 10px;
    border: 1px solid rgba(89, 89, 89, 0.12);
    padding: 0 15px 15px 15px;
    .header{
      color: #595959;
      font-size: 20px;
      border-bottom: 1px solid rgba(89, 89, 89, 0.12);
      font-weight: bold;
      padding: 15px 0;
    }
    .body{
      .history-container{
        overflow-y: auto;
        max-height: 155px;
        &::-webkit-scrollbar {
          display: none;
        }
        -ms-overflow-style: none;
        scrollbar-width: none;
        .history-item{
          display: flex;
          justify-content: space-between;
          padding: 10px 0;
          &:not(:last-child){
            border-bottom: 1px solid rgba(89, 89, 89, 0.12);
          }
        }
      }
    }
  }
}

.box-sell-meter{
  background: var(--v-bgPrimary-base);
  border: 1px solid  var(--v-primary-base);
  border-radius: 5px;
  padding: 20px;
  box-shadow: 0px 12px 44px 0px rgba(0, 0, 0, 0.12);
  .sell-section{
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 20px;
    align-items: end;
  }
}

.btn-history{
  background-color: var(--v-light-base);
  color: #000000;
  border-radius: 10px;
  &.active{
    background-color: #04926B !important;
    color: var(--v-light-base);
  }
}

.box-list-product{
  margin: 25px 0;
}

.divider-dashed{
  display: block;
  height: 1;
  border: 1px dashed var(--v-bgDarkgray-base);
}

.btn-link{
  padding: 0 !important;
  font-size: 16px;
  margin: 0 !important;
}

.table-item.header {
  background-color: rgb(0, 166, 80);

  th {
    color: white !important;
    font-size: 14px;
  }
}

.box-payment-container{
  border : 1px solid #E0F2F1;
  border-radius: 5px;
  padding: 20px;
}
</style>

<style lang="scss">
.alert-unit {
  .v-alert__border{
    opacity: 1;
    border-width: 4px;
  }
}
</style>